module.exports = __webpack_public_path__ + "static/media/Home PAG(A).605a8c9f.svg";